import { Roulette } from './Roulette';

// 画像をインポート
const items = [
    new URL('../assets/images/slot/1.jpg', import.meta.url).href,
    new URL('../assets/images/slot/2.jpeg', import.meta.url).href,
    new URL('../assets/images/slot/3.png', import.meta.url).href,
    // 必要な数だけ追加
];

window.addEventListener('DOMContentLoaded', () => {
    const rouletteContainer = document.getElementById('roulette-items')!;

    // ルーレットアイテムを作成
    items.forEach((item, index) => {
        const div = document.createElement('div');
        div.className = `roulette-item ${index === 0 ? 'active' : ''}`;
        div.style.backgroundImage = `url(${item})`;
        div.style.backgroundSize = 'contain';
        div.style.backgroundRepeat = 'no-repeat';
        div.style.backgroundPosition = 'center';
        rouletteContainer.appendChild(div);
    });

    // 背景画像を設定
    const bgUrl = new URL('../assets/images/background/bg.png', import.meta.url).href;
    document.getElementById('background')!.style.backgroundImage = `url(${bgUrl})`;

    // ルーレットを初期化
    new Roulette(items);
});